import { render } from "./ShopPage.vue?vue&type=template&id=5299d262&ts=true"
import script from "./ShopPage.vue?vue&type=script&lang=ts"
export * from "./ShopPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__